import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

import BackToSearch from '../../common/BackToSearch';
import TechDataPageHeader from './TechData/Detail/TechDataPageHeader';
import CardBase from '../../common/CardBase';
import TechDataCardBody from './TechData/Card/TechDataCardBody';
import TechDataCardLinks from './TechData/Card/TechDataCardLinks';
import FeaturedCard from '../../common/FeaturedCard/FeaturedCard';
import FeaturedCardDynamic from '../../common/FeaturedCard/FeaturedCardDynamic';

import { makeStyles, useTheme } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';

import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PrintOutlinedIcon from '@material-ui/icons/PrintOutlined';
import PictureAsPdfOutlinedIcon from '@material-ui/icons/PictureAsPdfOutlined';

import SummaryInfo from '../SummaryInfo';
import { useSiteInfo } from '../../crafter_site_core/hooks';
import { urlFromItemPathAndSlug } from '../EnterpriseContentDetailViewSlugSupport';
import Icon from '../../utils/icon';
import { usePencil } from '../../crafter_site_core/IceSupport';

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1
  },
  contentcolumn: {
    width: '100%',
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  quickinfo: {
    overflowY: 'scroll',
    '& h5': {
      paddingTop: theme.spacing(2)
    }
  },
  quickinfofooter: {
    background:
      'linear-gradient(0deg, rgba(245,247,250,1) 0%, rgba(245,247,250,0) 100%)'
  },
  quickinfomobilepanel: {
    borderRadius: theme.spacing(2) + 'px !important',
    backgroundColor: theme.palette.primary.lightest
    // [theme.breakpoints.up('md')]: {
    //   display: 'none',
    // },
  },
  quickinfomobilepanelsummary: {
    backgroundColor: theme.palette.primary.lighter,
    borderRadius: theme.spacing(2)
  },
  quickinfomobilepaneldetails: {
    backgroundColor: theme.palette.primary.lightest,
    flexDirection: 'column',
    '& a': {
      textDecoration: 'underline'
    },
    '& h3 a': {
      fontSize: '1.25rem',
      fontWeight: 500
    }
  },
  heroDisplay: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  featuredDisplay: {
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  },
  quickinfosmall: {
    paddingBottom: theme.spacing(3),
    fontStyle: 'italic',
    color: theme.palette.primary.main,
    [theme.breakpoints.up('sm')]: {
      display: 'none'
    }
  },
  logocontainer: {
    padding: theme.spacing(2, 0.5),
    '& svg': {
      width: '100%'
    }
  }
}));

export default function (props) {
  const ice = usePencil(props);
  const classes = useStyles();
  const theme = useTheme();
  const [expandQuickInfo, setQuickInfoExpand] = useState(true);
  function printPage(e) {
    e.preventDefault();
    window.print();
    return false;
  }

  const {
    format,
    model: {
      craftercms: { path },
      summary = SummaryInfo(props.model),
      body_html_raw,
      highlights_o,
      categories_o,
      pregnancyAlert_s,
      breastfeedingAlert_s,
      extraDosingConsiderationInfo_s,
      referenceBlock_html_raw,
      slug_s,
      pdf_o
    }
  } = props;
  const siteinfo = useSiteInfo();
  let cardImgUrl = '';

  if (siteinfo != null) {
    cardImgUrl = siteinfo.techDataDefaultCard_s;
  }

  if (summary.cardImage != null) {
    cardImgUrl = summary.cardImage;
  }

  function getHighlights(highlights) {
    return highlights?.map((item, key) => {
      return (
        <Box key={key}>
          {/* <Typography variant='h5' gutterBottom>
            {item.title_s}
          </Typography> */}
          <div
            dangerouslySetInnerHTML={{
              __html: item.body_html_raw
            }}
          />
        </Box>
      );
    });
  }

  function handleChange() {
    setQuickInfoExpand(!expandQuickInfo);
  }

  switch (format) {
    case 'DETAIL':
      return (
        <>
          <div id='home' />
          <Box width={270} className={classes.logocontainer + ' print-only'}>
            <Icon
              name='metagenics-institute-logo-stacked'
              heightsize={100}
              color='#002A54'
            />
          </Box>
          {/* BackToSearch is commented out until search can run with same filters on press or show same results (perhaps global context / state) when navigating back to the search page (memorisation (useMemo) not a use case for this perhaps?) */}
          <BackToSearch />
          <TechDataPageHeader
            ice={ice}
            title={summary.title}
            subtitle={summary.subtitle}
            categories={categories_o}
            pdf={pdf_o != null && pdf_o[0].craftercms.path}
          />
          <Container maxWidth='lg'>
            <Box
              display='flex'
              alignItems='center'
              justifyContent='space-between'
              className={classes.quickinfosmall}
              pr={3}
            >
              <Box
                pr={3}
                display='flex'
                alignItems='center'
                justifyContent='center'
                className='no-print'
              >
                <Typography
                  variant='overline'
                  style={{ fontWeight: 700, paddingRight: theme.spacing(1) }}
                >
                  Quick Links:
                </Typography>
                <Tooltip title='Print' aria-label='print'>
                  <IconButton aria-label='print' onClick={printPage}>
                    <PrintOutlinedIcon color='secondary' />
                  </IconButton>
                </Tooltip>
                <Tooltip title='Save PDF' aria-label='download'>
                  <IconButton
                    href='download pdf'
                    aria-label='download'
                    download
                  >
                    <PictureAsPdfOutlinedIcon color='secondary' />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
            <Box mb={2} {...ice}>
              <ExpansionPanel
                expanded={expandQuickInfo}
                elevation={0}
                className={classes.quickinfomobilepanel + ' promotionalcard'}
              >
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon color='secondary' />}
                  onClick={handleChange}
                  aria-controls='panel-content'
                  id='panel-header'
                  className={classes.quickinfomobilepanelsummary}
                >
                  <Box mr={1}>
                    <InfoOutlinedIcon />
                  </Box>
                  <Typography variant='h5'>Quick Info</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails
                  className={classes.quickinfomobilepaneldetails}
                >
                  <Box pb={2}>
                    <Box className='bodyhtmlraw'>
                      {getHighlights(highlights_o)}
                      <Box mt={0}>
                        <a
                          href='#dosing'
                          style={{ textDecoration: 'underline' }}
                        >
                          <Typography variant='h4' gutterBottom>
                            Dosing Considerations*
                          </Typography>
                        </a>
                        {extraDosingConsiderationInfo_s && (
                          <Box display='flex' alignItems='center' pl={1} pt={2}>
                            <Typography paragraph>
                              {extraDosingConsiderationInfo_s}
                            </Typography>
                          </Box>
                        )}
                        <Box display='flex' alignItems='center' pt={3}>
                          <Box mr={3}>
                            <Icon
                              heightsize={70}
                              widthsize={70}
                              name={'pregnancy'}
                            />
                          </Box>
                          <Box mr={4.8}>
                            <a
                              href='#pregnancy'
                              style={{ textDecoration: 'underline' }}
                            >
                              <Typography variant='h6' gutterBottom>
                                Pregnancy
                              </Typography>
                            </a>
                          </Box>
                          <Box
                            display='flex'
                            alignItems='center'
                            mb={1}
                            pl={1}
                            pt={1}
                          >
                            <Icon
                              heightsize={50}
                              widthsize={50}
                              name={'pregnancy-' + pregnancyAlert_s}
                            />
                          </Box>
                        </Box>
                        <Box display='flex' alignItems='center' pt={3}>
                          <Box mr={3}>
                            <Icon
                              heightsize={70}
                              widthsize={70}
                              name={'breastfeeding'}
                            />
                          </Box>
                          <Box mr={3}>
                            <a
                              href='#breastfeeding'
                              style={{ textDecoration: 'underline' }}
                            >
                              <Typography variant='h6' gutterBottom>
                                Breastfeeding
                              </Typography>
                            </a>
                          </Box>
                          <Box display='flex' alignItems='center' mb={1} pt={1}>
                            <Icon
                              heightsize={50}
                              widthsize={50}
                              name={'breastfeeding-' + breastfeedingAlert_s}
                            />
                          </Box>
                        </Box>
                        <Box mt={6}>
                          <Typography variant='subtitle'>
                            <strong>
                              *Dosing regimens should be determined by
                              appropriate assessment and monitoring.
                            </strong>
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            </Box>
            <Box display='flex'>
              <Box className={classes.contentcolumn}>
                <div
                  {...ice}
                  className='bodyhtmlraw accordion pbody'
                  dangerouslySetInnerHTML={{ __html: body_html_raw }}
                />
                {referenceBlock_html_raw && (
                  <Box mt={4} mb={2}>
                    <Typography variant='h4' gutterBottom>
                      References
                    </Typography>
                    <div
                      className='bodyhtmlraw'
                      dangerouslySetInnerHTML={{
                        __html: referenceBlock_html_raw
                      }}
                    />
                  </Box>
                )}
              </Box>
              {/* <Box position='relative' className={classes.quickinfocolumn}>
                <Box position='sticky' top={32}>
                  <Box
                    height='90vh'
                    bgcolor={theme.palette.primary.lightest}
                    px={3}
                    py={4}
                    className={classes.quickinfo}
                    borderLeft='1px solid rgba(0, 0, 0, 0.12)'
                    borderRadius={16}
                  >
                    <Box
                      height={50}
                      bgcolor={theme.palette.primary.lighter}
                      position='absolute'
                      left={0}
                      right={16}
                      top={0}
                      zIndex={2}
                      borderRadius='16px 0 0 0'
                    >
                      <Box
                        width={1}
                        height={1}
                        display='flex'
                        alignItems='center'
                        pl={2}
                      >
                        <Box mr={1}>
                          <InfoOutlinedIcon />
                        </Box>
                        <Typography variant='h4'>Quick Info</Typography>
                      </Box>
                    </Box>
                    <Box pt={2} pb={4}>
                      <Box className='bodyhtmlraw'>
                        {getHighlights(highlights_o)}
                        <Typography variant='h5' gutterBottom>
                          Breastfeeding
                        </Typography>
                        <Icon
                          heightsize={50}
                          widthsize={50}
                          name={'breastfeeding-' + breastfeedingAlert_s}
                        />
                        <Typography variant='h5' gutterBottom>
                          Pregnancy
                        </Typography>
                        <Icon
                          heightsize={50}
                          widthsize={50}
                          name={'pregnancy-' + pregnancyAlert_s}
                        />
                        <Typography variant='h5' gutterBottom>
                          Dosing Consideration
                        </Typography>
                        <Icon
                          heightsize={50}
                          widthsize={50}
                          name={'dosage-' + dosingConsiderations_s}
                        />
                      </Box>
                    </Box>
                    <Box
                      height={75}
                      position='absolute'
                      left={0}
                      right={15}
                      bottom={0}
                      zIndex={2}
                      className={classes.quickinfofooter}
                    ></Box>
                  </Box>
                </Box>
              </Box> */}
            </Box>
            <Box width={1} textAlign='center' mb={4}>
              <Button variant='outlined' color='secondary'>
                <a href='#home'>Back to Top</a>
              </Button>
            </Box>
          </Container>
        </>
      );
    case 'CARD':
      return (
        <CardBase contenttype='Technical Data' categories={categories_o}>
          <NavLink to={urlFromItemPathAndSlug(path, slug_s)} exact>
            <TechDataCardBody
              title={summary.title}
              subtitle={summary.subtitle}
              snippet={summary.snippet}
            />
          </NavLink>
          <TechDataCardLinks
            buttontext='read now'
            link={urlFromItemPathAndSlug(path, slug_s)}
            pdf={pdf_o != null && pdf_o[0].craftercms.path}
          />
        </CardBase>
      );
    case 'FEATURED':
      return (
        <FeaturedCardDynamic
          contenttype='Technical Data'
          title={summary.title}
          subtitle={summary.subtitle}
          snippet={summary.snippet}
          buttontext='read now'
          categories={categories_o}
          image={cardImgUrl}
          icon='tech-data'
          link={urlFromItemPathAndSlug(path, slug_s)}
        />
      );
    case 'HERO':
      return (
        <Container maxWidth='lg'>
          <div className={classes.heroDisplay}>
            <FeaturedCard
              contenttype='Technical Data'
              title={summary.title}
              subtitle={summary.subtitle}
              snippet={summary.snippet}
              buttontext='read now'
              categories={categories_o}
              image={cardImgUrl}
              link={urlFromItemPathAndSlug(path, slug_s)}
              icon='tech-data'
            />
          </div>
          <div className={classes.featuredDisplay}>
            <FeaturedCardDynamic
              contenttype='Technical Data'
              title={summary.title}
              subtitle={summary.subtitle}
              snippet={summary.snippet}
              buttontext='read now'
              categories={categories_o}
              image={cardImgUrl}
              icon='tech-data'
              link={urlFromItemPathAndSlug(path, slug_s)}
            />
          </div>
        </Container>
      );
    default:
      console.error(`Unknown format "${format}"."`);
      return <h1>Unknown format.</h1>;
  }
}
